import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";

export const useUploadVesselInfo = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const uploadVesselInfo = async ({ formData, vesselType }) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_SERVER_URL}/vessel/upload/primaryInformation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ ...formData, vesselType }),
        }
      );

      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message);
      }

      const data = await response.json();

      // Save the vessel ID to local storage
      localStorage.setItem('vesselId', data.data._id);
      
      return data;
    } catch (error) {
      throw new Error(error.message);
    }
  };

  return useMutation(uploadVesselInfo, {
    onSuccess: () => {
      queryClient.invalidateQueries("vesselData");
      navigate("/vessel_general_information");
    },
  });
};

